
const RECAPTCHA_SITE_KEY = '6Ld4r1gtAAAAALFCACBD0sCY3j1rp9BoXqIkKKPl';

if (document.querySelector(".recaptcha_form") !== null) {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=" + RECAPTCHA_SITE_KEY;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
}



document.querySelectorAll(".recaptcha_form").forEach(function (element) {

    let input = document.createElement("input");
    input.type = "hidden";
    input.name = "recaptcha_token";

    element.addEventListener('submit', function(e) {
        e.preventDefault();

        // HTML5バリデーションを手動で実行
        if (!e.target.checkValidity()) {
            e.target.reportValidity(); // エラーメッセージを表示
            return;
        }
        grecaptcha.ready(function() {
            grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'submit'})
                .then(function(token) {
                    input.value = token;
                    e.target.submit();
                });
        });
    });
    element.appendChild(input)

})
